_ = require('underscore');
module.exports = {
    "favoritesWrapperTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div id="portfolioNavMainContainer"></div>\n    <div id="portfolioLoadingContainer" class="portfolio-loading-container"></div>\n    <div id="portfolioTabContainer">\n        <div id="itemsContainer"></div>\n        <div id="followingContainer" class="boxSizingWrapper"></div>\n        <div id="errorContainer"></div>\n        <div id="messageContainer"></div>\n    </div>\n';
return __p
},
    "portfolioWrapperTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div id="sectionLists"></div>\n    <div id="sectionPortfolio"></div>\n';
return __p
},
    "portfolioPageTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div id="portfolioToolbarContainer"></div>\n    <div id="pageViewContainer"></div>\n';
return __p
},
    "portfolioNavMainTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="portfolio-nav-main">\n        <div class="portfolio-title h1">My Favorites</div>\n        <div class="portfolio-nav-main-container-inner cf">\n            <div class="portfolio-nav-main" data-tn="portfolio-nav-main">\n                <a href="#toggle-items" id="toggleItems" class="portfolio-toggle-section';
 if (obj.tab === 'items') { ;
__p += ' is-selected';
 } ;
__p += '" data-galabel="all items" data-tn="toggle-items">Items</a>\n                <a href="#toggle-following" id="toggleFollowing" class="portfolio-toggle-section';
 if (obj.tab === 'following') { ;
__p += ' is-selected';
 } ;
__p += '" data-galabel="following" data-tn="toggle-following">Following</a>\n            </div>\n        </div>\n        <div class="portfolio-nav-indicator-track">\n            <div class="portfolio-nav-indicator" data-tn="portfolio-nav-indicator"></div>\n        </div>\n    </div>\n';
return __p
},
    "settingsModalTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="modal-body" data-tn="settings-modal">\n        <div class="modal-section">\n            <div class="modal-label" data-tn="settings-modal-privacy-label">' +
((__t = ( obj.options.copy.settingsPrivacyHeader )) == null ? '' : __t) +
'</div>\n            <label class="prettycheck privacy-setting">\n                <input type="radio" name="privacySetting.privacyLevel" value="' +
((__t = ( obj.options.modelClass.PRIVACY_PUBLIC )) == null ? '' : __t) +
'" data-tn="settings-modal-privacy-public">\n                <span class="input-label fauxinput">' +
((__t = ( obj.options.copy.settingsPrivacyPublic )) == null ? '' : __t) +
'</span>\n            </label>\n            <label class="prettycheck privacy-setting">\n                <input type="radio\' name="privacySetting.privacyLevel" value="' +
((__t = ( obj.options.modelClass.PRIVACY_PRIVATE )) == null ? '' : __t) +
'"" data-tn="settings-modal-privacy-private">\n                <span class="input-label fauxinput">' +
((__t = ( obj.options.copy.settingsPrivacyPrivate )) == null ? '' : __t) +
'</span>\n            </label>\n        </div>\n        <div class="modal-actions">\n            <button class="modal-action button-medium button-primary" data-tn="settings-modal-privacy-save" save>' +
((__t = ( obj.options.copy.modalLabels.save )) == null ? '' : __t) +
'</button>\n        </div>\n    </div>\n';
return __p
},
    "settingPrivacyModal": function(obj) {
var __t, __p = '';
__p += '\n    <div class="modal-header">' +
((__t = ( obj.options.copy.modalLabels.sharingSettings )) == null ? '' : __t) +
'</div>\n    <div class="modal-body">\n        <div class="modal-section">\n            <div class="modal-label">' +
((__t = ( obj.options.copy.settingsPrivacyHeader )) == null ? '' : __t) +
'</div>\n            <label class="prettycheck privacy-setting">\n                <input type="radio" name="privacySetting.privacyLevel" value="' +
((__t = ( obj.options.modelClass.PRIVACY_PUBLIC )) == null ? '' : __t) +
'">\n                <span class="input-label fauxinput">' +
((__t = ( obj.options.copy.settingsPrivacyPublic )) == null ? '' : __t) +
'</span>\n            </label>\n            <label class="prettycheck privacy-setting">\n                <input type="radio" name="privacySetting.privacyLevel" value="' +
((__t = ( obj.options.modelClass.PRIVACY_PRIVATE )) == null ? '' : __t) +
'">\n                <span class="input-label fauxinput">' +
((__t = ( obj.options.copy.settingsPrivacyPrivate )) == null ? '' : __t) +
'</span>\n            </label>\n        </div>\n        <div class="modal-actions">\n            <button class="modal-action button-medium button-primary" save>' +
((__t = ( obj.options.copy.modalLabels.save )) == null ? '' : __t) +
'</button>\n        </div>\n    </div>\n';
return __p
},
    "settingEditNameModal": function(obj) {
var __t, __p = '';
__p += '\n    <div class="modal-header">' +
((__t = ( (2 < obj.options.level) ? obj.options.copy.modalLabels.editSubFolder : obj.options.copy.modalLabels.editFolder )) == null ? '' : __t) +
'</div>\n    <div class="modal-body">\n        <div class="modal-section">\n            <div class="modal-label">' +
((__t = ( obj.options.copy.modalLabels.name )) == null ? '' : __t) +
'\n                <span class="errflag"></span>\n            </div>\n            <input class="form-input" type="text" name="name" data-tn="settings-edit-name-input">\n        </div>\n        <div class="modal-actions">\n            <button class="modal-action button-medium button-primary" data-tn="settings-edit-name-save" save>' +
((__t = ( obj.options.copy.modalLabels.save )) == null ? '' : __t) +
'</button>\n        </div>\n    </div>\n';
return __p
},
    "portfolioToolbarTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="portfolio-toolbar cf"></div>\n';
return __p
},
    "editMenuItem": function(obj) {
var __t, __p = '';
__p += '\n    <li class="edit-dropdown-item" data-modal-show="' +
((__t = ( obj.modalName )) == null ? '' : __t) +
'">' +
((__t = ( obj.label )) == null ? '' : __t) +
'</li>\n';
return __p
},
    "portfolioDropdownTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    ';
 if (obj.dropdownPortfolios && obj.dropdownPortfolios.length) { ;
__p += '\n        <div class="portfolio-p3-dropdown">\n            <select class="portfolio-p3-dropdown-select';
 if (obj.isP2) { ;
__p += ' is-all';
 } ;
__p += '">\n                ';
 obj.dropdownPortfolios.each(function (portfolio, index) { ;
__p += '\n                    <option value="' +
((__t = ( index )) == null ? '' : __t) +
'"';
 if (portfolio.id === obj.selectedId) { ;
__p += ' selected="1"';
 } ;
__p += '>\n                        ';
 if (portfolio.id === obj.allId) { ;
__p += '\n                            All Subfolders\n                        ';
 } else { ;
__p += '\n                            ' +
((__t = ( portfolio.get('name') )) == null ? '' : __t) +
'\n                        ';
 } ;
__p += '\n                    </option>\n                ';
 }) ;
__p += '\n            </select>\n        </div>\n    ';
 } ;
__p += '\n';
return __p
},
    "portfolioSearchTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="portfolio-search">\n        <form class="portfolio-search-form cf">\n            <div class="portfolio-search-input-wrap">\n                <input type="text" name="portfolioSearch" class="portfolio-search-input" placeholder="' +
((__t = ( obj.copySearchPlaceholder )) == null ? '' : __t) +
'" value="">\n                <div class="portfolio-search-button-wrap">\n                    <a href="#clear-term" class="portfolio-search-clear-button">\n                        ' +
((__t = ( obj.closeIcon )) == null ? '' : __t) +
'\n                    </a>\n                    <button type="submit" class="portfolio-search-button">\n                        ' +
((__t = ( obj.magnifyingGlassIcon )) == null ? '' : __t) +
'\n                    </button>\n                </div>\n            </div>\n        </form>\n    </div>\n    ';
 if (obj.query) { ;
__p += '\n        <span class="portfolio-search-summary ellipsis">\n            ' +
((__t = ( obj.totalResults )) == null ? '' : __t) +
' result' +
((__t = ( obj.totalResults === 1 ? '' : 's' )) == null ? '' : __t) +
' for "' +
((__t = ( obj.query )) == null ? '' : __t) +
'"\n        </span>\n    ';
 } ;
__p += '\n';
return __p
},
    "portfolioToggleLayoutTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <a href="#toggle-row" id="toggleRow" class="' +
((__t = ( obj.toggleRowClass )) == null ? '' : __t) +
'" data-galabel="click to view as list">' +
((__t = ( obj.listIcon )) == null ? '' : __t) +
'</a>\n    <a href="#toggle-grid" id="toggleGrid" class="' +
((__t = ( obj.toggleGridClass )) == null ? '' : __t) +
'" data-galabel="click to view as grid">' +
((__t = ( obj.gridIcon )) == null ? '' : __t) +
'</a>\n';
return __p
},
    "portfolioRowItemTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="imageDiv colXs12 colMd3"></div>\n    <div class="colXs12 colMd6">\n        <div class="rowSectionCenter">\n            ' +
((__t = ( obj.titleHtml )) == null ? '' : __t) +
'\n            ' +
((__t = ( obj.dealerHtml )) == null ? '' : __t) +
'\n            ' +
((__t = ( obj.priceHtml )) == null ? '' : __t) +
'\n            ' +
((__t = ( obj.itemActionButtonsHtml)) == null ? '' : __t) +
'\n            <div class="js-contact-dealer"></div>\n            <div class="portfolio-row-item-contact-dealer-link-wrapper">\n                <a class="portfolio-row-item-contact-dealer-link" href="#">contact dealer</a>\n            </div>\n        </div>\n    </div>\n    <div class="colXs12 colMd3">\n        <div class="actionsDiv rowSectionRight"></div>\n    </div>\n';
return __p
},
    "portfolioRowPlaceholderTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <li class="portfolio-row-item">\n        <div class="portfolio-row-placeholder-inner"></div>\n        <div class="portfolio-row-placeholder-inner"></div>\n        <div class="portfolio-row-placeholder-inner"></div>\n    </li>\n';
return __p
},
    "portfolioGridItemTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-inner">\n        <div class="imageDiv isGrid"></div>\n        ' +
((__t = ( obj.titleHtml )) == null ? '' : __t) +
'\n        ' +
((__t = ( obj.dealerHtml )) == null ? '' : __t) +
'\n        ' +
((__t = ( obj.priceHtml )) == null ? '' : __t) +
'\n        <div class="actionsDiv"></div>\n    </div>\n';
return __p
},
    "portfolioItemImageTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    ';
 if (obj.isUnavailable) { ;
__p += '\n        <div class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-image-unavailable">\n            <div class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-image-unavailable-text">\n                <p>Image</p>\n                <p>Not</p>\n                <p>Available</p>\n            </div>\n        </div>\n    ';
 } else { ;
__p += '\n        <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link has-image link-pdp" data-galocation="item image">\n            <img src="' +
((__t = ( obj.imageUrl )) == null ? '' : __t) +
'" alt="' +
((__t = ( obj.title )) == null ? '' : __t) +
'" class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-image is-centered">\n        </a>\n    ';
 } ;
__p += '\n';
return __p
},
    "portfolioItemTitleTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-name" data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-name">\n        ';
 if (obj.isUnavailable) { ;
__p += '\n            <span class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link-name" data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link-name">\n                ' +
((__t = ( obj.title )) == null ? '' : __t) +
'\n            </span>\n        ';
 } else if (obj.isArtCreator) { ;
__p += '\n            <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link" class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link link-pdp';
 if (obj.isGrid) { ;
__p += ' ellipsis';
 } ;
__p += '" data-galocation="item title">\n                ' +
((__t = ( obj.creator )) == null ? '' : __t) +
'\n            </a>\n            <div data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-art-title" class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-art-title';
 if (obj.isGrid) { ;
__p += ' ellipsis multiline';
 } ;
__p += '">\n                <span class="italic">' +
((__t = ( obj.title )) == null ? '' : __t) +
'</span>';
 if (obj.creationDate) { ;
__p += ', ' +
((__t = ( obj.creationDate )) == null ? '' : __t);
 } ;
__p += '\n            </div>\n        ';
 } else { ;
__p += '\n            <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link" class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link link-pdp';
 if (obj.isGrid) { ;
__p += ' ellipsis multiline';
 } ;
__p += '" data-galocation="item title">\n                ' +
((__t = ( obj.title )) == null ? '' : __t) +
'\n            </a>\n        ';
 } ;
__p += '\n    </div>\n';
return __p
},
    "portfolioItemDealerTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    ';
 if (!obj.isUnavailable) { ;
__p += '\n        <div class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-dealer';
 if (obj.isGrid) { ;
__p += ' ellipsis';
 } ;
__p += '" data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-dealer">\n            Offered by ' +
((__t = ( obj.dealerCompany )) == null ? '' : __t) +
'\n        </div>\n    ';
 } ;
__p += '\n';
return __p
},
    "portfolioItemPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="portfolio-price-wrapper"></div>\n';
return __p
},
    "portfolioItemActionButtonsTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="portfolio-row-action-buttons-container"></div>\n';
return __p
},
    "portfolioErrorTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="portfolio-error-container">\n        <div class="portfolio-error-message">\n            ' +
((__t = ( obj.copyServiceError )) == null ? '' : __t) +
'\n            ';
 if (obj.showError && obj.errorMessage) { ;
__p += '\n                <p class="portfolio-error-dev">' +
((__t = ( obj.errorMessage )) == null ? '' : __t) +
'</p>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n';
return __p
},
    "portfolioMessageTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="portfolio-message-container" data-tn="portfolio-message-container">\n        <div class="portfolio-message-message-container">\n            <div class="portfolio-message-message" data-tn="portfolio-message-copy">\n                ' +
((__t = ( obj.copy )) == null ? '' : __t) +
'\n            </div>\n        </div>\n        <div class="portfolio-message-link-group-container">\n            <div class="portfolio-message-link-left">\n                <div class="portfolio-message-link-group portfolio-message-verticals"></div>\n                <div class="portfolio-message-link-group portfolio-message-collections"></div>\n            </div>\n            <div class="portfolio-message-link-right">\n                <div class="portfolio-message-link-group portfolio-message-creators"></div>\n            </div>\n        </div>\n    </div>\n';
return __p
},
    "portfolioMessageLinkGroupTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <h3 class="portfolio-message-link-group-header">\n        ' +
((__t = ( obj.linkGroup.name )) == null ? '' : __t) +
'\n    </h3>\n    <ul>\n        ';
 _.each(obj.linkGroup.links, function(link, index) { ;
__p += '\n            <li class="portfolio-message-link-container">\n                <a href="' +
((__t = ( link.uri )) == null ? '' : __t) +
'" class="portfolio-link">\n                    ' +
((__t = ( link.name )) == null ? '' : __t) +
'\n                </a>\n            </li>\n        ';
 }); ;
__p += '\n    </ul>\n';
return __p
},
    "portfolioListsTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div id="portfolioList" class="portfolio-lists-container row cf">\n    </div>\n';
return __p
},
    "portfolioListsP2Tmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="portfolio-lists-p2-container-inner">\n        <div class="portfolio-lists-preview-main" data-tn="portfolio-favorite-preview-main">\n            ';
 if (obj.preview1) { ;
__p += '\n                <img src="' +
((__t = ( obj.preview1 )) == null ? '' : __t) +
'" class="portfolio-lists-preview-image" data-tn="portfolio-favorite-preview-image">\n            ';
 } ;
__p += '\n        </div>\n        <div class="portfolio-lists-preview-sub-container row cf">\n            ';
 for (var i=2; i<=4; i++) { ;
__p += '\n                <div class="portfolio-lists-preview-sub">\n                    ';
 var imgSrc = obj['preview' + i];
                    if (imgSrc) { ;
__p += '\n                        <img src="' +
((__t = ( imgSrc )) == null ? '' : __t) +
'" class="portfolio-lists-preview-image" data-tn="portfolio-favorite-preview-image-' +
((__t = ( i )) == null ? '' : __t) +
'">\n                    ';
 } ;
__p += '\n                </div>\n            ';
 } ;
__p += '\n        </div>\n        <div class="portfolio-lists-name-container">\n            <span class="portfolio-lists-name ellipsis">' +
((__t = ( obj.name )) == null ? '' : __t) +
'</span>\n            <span class="portfolio-lists-count"> - ' +
((__t = ( obj.numItemsCopy )) == null ? '' : __t) +
'</span>\n        </div>\n    </div>\n';
return __p
},
    "portfolioCreateP2Tmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="portfolio-lists-create-container-inner">\n        <div class="portfolio-lists-create-section toggle-overlay">\n            <div class="portfolio-lists-create-circle">\n                ' +
((__t = ( obj.plusIcon )) == null ? '' : __t) +
'\n            </div>\n            <div class="portfolio-lists-create-text">\n                ' +
((__t = ( obj.copyCreateP2 )) == null ? '' : __t) +
'\n            </div>\n        </div>\n        <div class="portfolio-lists-create-section is-hidden">\n            <div class="portfolio-lists-create-close toggle-overlay">\n                ' +
((__t = ( obj.closeIcon )) == null ? '' : __t) +
'\n            </div>\n            <form class="portfolio-lists-create-form">\n                <div class="portfolio-lists-create-label">\n                    ' +
((__t = ( obj.copyCreateP2 )) == null ? '' : __t) +
'\n                </div>\n                <input type="text" id="listName" name="listName" class="portfolio-lists-create-input validation-field" placeholder="' +
((__t = ( obj.copyCreateP2Placeholder )) == null ? '' : __t) +
'">\n                <button id="portfolioCreateP2Submit" class="portfolio-lists-create-button button-medium full-width button-primary">Create</button>\n            </form>\n        </div>\n    </div>\n';
return __p
},
    "portfolioShareTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <h2 class="modal-header">' +
((__t = ( obj.copyShareHeader )) == null ? '' : __t) +
'</h2>\n    <div class="modal-body">\n        <form class="portfolio-modal-form">\n            <fieldset class="portfolio-modal-fields">\n                <div class="portfolio-modal-form-row share-name">\n                <span class="is-hidden form-errflag-above">Required Field</span>\n                    <label for="userName" class="portfolio-modal-label">\n                        Your Name<span class="is-required">*</span>\n                    </label>\n                    <input type="text" id="userName" class="portfolio-modal-field is-required" name="senderName" value="' +
((__t = ( obj.userName || '' )) == null ? '' : __t) +
'" />\n                </div>\n                <div class="portfolio-modal-form-row share-to">\n                    <span class="is-hidden form-errflag-above">Required Field</span>\n                    <label for="shareTo" class="portfolio-modal-label">\n                        Recipient&#39;s Email<span class="is-required">*</span>\n                    </label>\n                    <input type="text" id="shareTo" class="portfolio-modal-field is-required" name="recepientEmails" />\n                    <div class="portfolio-modal-field-note">' +
((__t = ( obj.copyShareMultipleEmail )) == null ? '' : __t) +
'</div>\n                </div>\n                <div class="portfolio-modal-form-row share-message">\n                    <label for="userMessage" class="portfolio-modal-label">Message <span class="is-optional">(optional)</span></label>\n                    <textarea maxlength="500" rows="3" id="userMessage" class="portfolio-modal-field" name="message" placeholder="' +
((__t = ( obj.copyShareMessagePlaceholder )) == null ? '' : __t) +
'"></textarea>\n                </div>\n            </fieldset>\n        </form>\n        <div class="portfolio-modal-notice privacy-notice cf">\n            <span class="privacy-notice-inline">' +
((__t = ( obj.copySharePrivacyNotice )) == null ? '' : __t) +
'</span>\n        </div>\n        <div class="modal-actions">\n            <span class="modal-action portfolio-share-confirm button-medium button-primary">SEND EMAIL</span>\n        </div>\n    </div>\n';
return __p
},
    "page-view-container": function(obj) {
var __t, __p = '';
__p += '\n    <ul class="boxSizingWrapper containerFluid page-body is-' +
((__t = ( this.subViewOptions.layout )) == null ? '' : __t) +
' portfolio-' +
((__t = ( this.subViewOptions.layout )) == null ? '' : __t) +
'-container row cf is-sortable"></ul>\n    <div class="page-links-container page-links-bottom pagination"></div>\n';
return __p
},
    "favoriteContactedDealer": function(obj) {
var __t, __p = '';
__p += '\n    <div class="email-success email-success-message">\n         ' +
((__t = ( obj.successMessage )) == null ? '' : __t) +
'\n    </div>\n    <div class="favorite-dealer-info is-hidden">\n        <div class="email-success-divider"></div>\n        <div class="email-success email-success-header">\n            ' +
((__t = ( obj.copy('successInfoHeader') )) == null ? '' : __t) +
'\n        </div>\n        <div class="email-success email-success-subtext">\n            ' +
((__t = ( obj.successInfoSubtext )) == null ? '' : __t) +
'\n        </div>\n    </div>\n\n    <div class="favorite-dealer-cta-container"></div>\n\n    <div class="favorite-dealer-cta-wrapper is-hidden">\n        <a href="#" class="favorite-dealer-cta no-thanks">' +
((__t = ( obj.copy('noThanksCta') )) == null ? '' : __t) +
'</a>\n    </div>\n';
return __p
}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/templates/favorites/main.html
// module id = 443
// module chunks = 4 6 8 9 12 17 19